
export default {
  // we define all attirbutes that input will have. Other props passed will become attribute of the DIV container.
  props: {
    id: {
      type: String,
    },
    type: {
      type: String,
    },
    required: {
      type: Boolean,
    },
    name: {
      type: String,
    },
    initialvalue: {
      type: String,
    },
    label: {
      type: String,
    },
    helper: {
      type: [String, Object],
    },
    helperError: {
      type: String,
    },
    disabled: {
      type: Boolean,
    },
    autocomplete: {
      type: String,
    },
    validation: {
      type: Object,
    },
    labelOptional: {
      type: String,
    },
    error: {
      type: String,
    },
  },
  data: function () {
    return {
      isFloating: this.initialvalue && this.initialvalue.trim() !== '',
      isValidRow: false,
      isInValidRow: false,
      value: this.initialvalue || '',
      $dirty: false,
      helperIsVisible: true,
    }
  },
  computed: {
    isEmptyRow() {
      return this.value === ''
    },
  },
  watch: {
    value(value) {
      this.$dirty = true
      if (this.validation) {
        this.validation.$model = value
      }
    },
    validation: {
      handler() {
        this.validateRow()
      },
      deep: true,
    },
  },
  methods: {
    validateOnEvents: () => true,
    validateRow: function () {
      if (!this.validateOnEvents()) return

      if (this.validation) {
        this.isValidRow = this.validation.$dirty && !this.validation.$invalid
        this.$emit('inputError', !this.isValidRow)
      } else {
        const field = this.$refs.field

        // this check for all native html attributes to check (required, pattern)
        this.isValidRow = field.checkValidity()
      }

      this.isInValidRow = this.validation.$error

      if (!this.validation.$invalid && this.validation.$model === '') {
        this.isValidRow = false
      }
      const formControlValue = this.validation.$model?.toString()
      if (formControlValue && formControlValue?.trim() !== '') {
        this.isFloating = true
        if (this.type == 'checkbox') {
          if (formControlValue.trim() == 'true') {
            this.value = formControlValue.trim()
          } else {
            this.value = ''
          }
        } else {
          this.value = formControlValue.trim()
        }
      } else {
        this.value = formControlValue?.trim()
        this.isFloating = false
      }
    },
    onFocusOut: function (e) {
      // focus out
      if (this.isEmptyRow) {
        this.isFloating = false
      }
      this.validateRow()
      this.$emit('onFocusOut', e)
    },
    onFocusIn: function () {
      // focus in
      this.isFloating = true
      if (this.validation && !this.isEmptyRow) {
        this.validation.$touch()
      }
    },
  },
}
